export class UserDetails {
  name: string;
  email: string;
  two_factor_enabled: boolean;
}
